import { BellIcon } from "@heroicons/react/20/solid";
import { io } from "socket.io-client";
import { useState, useRef, useEffect } from "react";
import monaLogo from "../assets/mona-mascot-temp.png";
import { useFetch } from "../hooks/useFetch";
import primeClient from "../axios/primeClient";
import { data } from "autoprefixer";
import hiClient from "../axios/hiClient";

const initializeSocket = (loginType, api_token) => {
  if (loginType === "hi") {
    return io(process.env.REACT_APP_HI_API, {
      path: "/api-mona-hi/ws/socket.io",
      extraHeaders: {
        token: api_token,
      },
    });
  } else {
    return io(process.env.REACT_APP_PRIME_API, {
      path: "/api-mona-prime/ws/socket.io",
      extraHeaders: {
        token: api_token,
      },
    });
  }
};

export const Notification = () => {
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const notificationRef = useRef(null);

  const loginType = localStorage.getItem("login_type");
  // if (loginType === "prime") {
  //   let {
  //     data: alarms,
  //     isLoading,
  //     error,
  //   } = useFetch({
  //     url: "/v1/apps/alarm/count",
  //     client: primeClient,
  //     initialData: [],
  //   });
  // } else {
  //   let {
  //     data: alarms,
  //     isLoading,
  //     error,
  //   } = useFetch({
  //     url: "/v1/apps/alarm/count",
  //     client: hiClient,
  //     initialData: [],
  //   });
  // }
  useEffect(() => {
    const api_token = localStorage.getItem("api_token");

    // const socket = initializeSocket(loginType, api_token);

    // socket.on("connect", () => {
    //   console.log("Connected to server with socket ID:", socket.id);

    //   socket.io.opts.auth = {
    //     token: api_token,
    //   };
    // });

    // socket.on("connect_error", (error) => {
    //   console.error("Connection Error:", error);
    // });

    // socket.on("notification", (data) => {
    //   console.log("Received notification:", data);
    //   setNotifications([...notifications, data]);
    // });

    const handleClickOutside = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setIsNotificationOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      style={{
        position: "relative",
        display: "inline-block",
      }}
    >
      <div
        style={{
          position: "relative",
          display: "inline-block",
        }}
      >
        <BellIcon
          ref={notificationRef}
          style={{
            width: "24px",
            height: "24px",
            color: "darkgray",
            cursor: "pointer",
          }}
          onClick={() => setIsNotificationOpen((prev) => !prev)}
        />
        {notifications.length > 0 && (
          <div
            style={{
              position: "absolute",
              top: "-5px",
              right: "-5px",
              backgroundColor: "red",
              color: "white",
              borderRadius: "50%",
              width: "16px",
              height: "16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "12px",
              fontWeight: "bold",
              lineHeight: "1",
              boxShadow: "0 0 4px rgba(0, 0, 0, 0.2)",
            }}
          >
            {notifications.length}
          </div>
        )}
      </div>
      {isNotificationOpen && (
        <div
          style={{
            position: "absolute",
            top: "auto",
            right: "0",
            backgroundColor: "white",
            border: "1px solid #ddd",
            borderRadius: "4px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            zIndex: 1000,
            width: "300px",
          }}
        >
          {/* Scrollable Container */}
          <div
            style={{
              maxHeight: "200px",
              overflowY: "auto",
            }}
          >
            {notifications.length === 0 ? (
              <div style={{ textAlign: "center", padding: "1rem 0" }}>
                No notifications available
              </div>
            ) : (
              notifications.map((el, idx) => (
                <div
                  style={{
                    padding: "0.5rem",
                    fontSize: "0.8rem",
                    borderBottom: "1px solid #ddd",
                    display: "flex",
                    alignItems: "center",
                    gap: "1rem",
                  }}
                >
                  <img
                    src={monaLogo}
                    alt="Mona"
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      objectPosition: "50% 20%",
                      border: "2px solid #d4e0ee",
                      flexShrink: 0,
                    }}
                  />
                  <div>
                    <h3 style={{ fontWeight: "bold" }}>{el.title}</h3>
                    <p style={{ color: "#686868" }}>{el.content}</p>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};
